import React from "react";

const ContextMenuItem = ({ onClick, title, type, children }) => {
  let className = "flex items-center px-3 py-2 gap-2 cursor-pointer select-none text-sm transition-all ";
  className += type === "danger" ? "bg-red text-white hover:opacity-70" : "text-black dark:text-white hover:bg-black-050 hover:dark:bg-black-700";

  return (
    <div className={className} onClick={onClick} title={title}>
      {children}
    </div>
  );
};

export default ContextMenuItem;
